import { FC } from 'react';
import { Form } from '@repo-level/core-front';
import styled from 'styled-components/macro';

import { device } from 'components/styles/MediaQuery';
import { OfUnion } from 'types/common';

const ScFieldBanner = styled.div`
  .payments-js-lib {
    &__wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 24px 0;
    }
    &__img-wrapper {
    }
    &__description {
      padding-left: 16px;
      font-size: 14px;
      @media (${device.mobile}) {
        font-size: 12px;
      }
    }
  }
`;

export const FieldBanner: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Banner]
> = ({ htmlContent }) => {
  return <ScFieldBanner dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};
